import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useGetChatUsersQuery } from "../Redux/api/chatApi";
import { useGetNotificationsQuery } from "../Redux/api/notificationApi";
import { useGetDefaultPaymentMethodQuery } from "../Redux/api/stripeApi";
import { setChatUsers, setDefaultPaymentMethod, setShowBackButton } from "../Redux/slices/GlobalSlice";
import { setHasNotifications, setNotficationCount, setRead } from "../Redux/slices/NotificationSlice";
import { useAppDispatch, useAppSelector } from "../Redux/store";
import { ProfileType } from "../Types/General";
import { useAWSWebsocket } from "./useAWSWebsocket";
// import { useBookmarks } from "./useBookmarks";
import { useSubscription } from "./useSubscription";
import { useUser } from "./useUser";

interface useInitializeAppProps {}

export const useInitializeApp = () => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { locator, type } = useUser();
    const isClient = type === ProfileType.Client;
    const {data: notifications} = useGetNotificationsQuery(locator || skipToken);
    const {data: chatUsersResponse} = useGetChatUsersQuery();
    const { chatUsers} = useAppSelector(state => state.Global);
    // useBookmarks();
    useAWSWebsocket();
    useSubscription();
    /* ******************** Variables ******************** */
    const hasNotifications = useAppSelector( state => state.Notification.hasNotifications);
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    useEffect(() => {
        const notificationCount = (notifications?.length ?? 0)
        if (notificationCount > 0) {
        if (!notifications?.some( n => n.read)) dispatch(setHasNotifications(true));
        dispatch(setNotficationCount(notificationCount));
        }
        if (notificationCount === 0 && hasNotifications) dispatch(setHasNotifications(false));
    }, [notifications])
    useEffect(() => {
        if (chatUsersResponse) {
        dispatch(setChatUsers(chatUsersResponse));
        } 
        if (!chatUsersResponse && chatUsers) {
        dispatch(setChatUsers(null));
        }
    }, [chatUsersResponse])
    useEffect(()=>{
      dispatch(setShowBackButton(false));
      dispatch(setRead([]));
    }, [])
    /* ******************** JSX ******************** */
    return {
    }
}